"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { Accordion } from "@nxt-costco-com/forge-components";
import { ItemIconTitle } from "../../ItemIconTitle/index.js";
import { getAccordionSx, getAccordionSummarySx, accordionDetailsSx } from "./styles.js";
const AccordionItem = forwardRef(
  ({
    activeTextBackgroundColor,
    activeTextColor,
    activeDividerColor,
    defaultTextBackgroundColor,
    defaultTextColor,
    defaultDividerColor,
    hoverTextBackgroundColor,
    hoverTextColor,
    hoverDividerColor,
    icons,
    isActive,
    isExpanded,
    details,
    onChange,
    titles
  }, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const useActiveStyles = isActive;
    const useHoverStyles = isFocused || isHovered;
    const backgroundColor = useActiveStyles ? activeTextBackgroundColor : useHoverStyles ? hoverTextBackgroundColor : defaultTextBackgroundColor;
    const accordionSx = getAccordionSx(
      defaultDividerColor,
      hoverDividerColor,
      activeDividerColor
    );
    const accordionSummarySx = getAccordionSummarySx(backgroundColor);
    const handleAccordionChange = () => {
      onChange();
    };
    return /* @__PURE__ */ jsx(
      Accordion,
      {
        expandIconSx: {
          color: useActiveStyles ? activeTextColor : defaultTextColor
        },
        secondaryComponent: /* @__PURE__ */ jsx(
          ItemIconTitle,
          {
            activeTextBackgroundColor,
            activeTextColor,
            defaultTextBackgroundColor,
            defaultTextColor,
            hoverTextBackgroundColor,
            hoverTextColor,
            icons,
            ref,
            titles,
            useActiveStyles,
            useHoverStyles
          }
        ),
        accordionDetailsSx,
        accordionSummarySx,
        accordionSx,
        disableGutters: true,
        displayTitle: false,
        isExpanded,
        onBlur: () => setIsFocused(false),
        onChange: handleAccordionChange,
        onFocus: () => setIsFocused(true),
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        children: isExpanded ? details : null
      }
    );
  }
);
AccordionItem.displayName = "AccordionItem";
export {
  AccordionItem
};
